import React from 'react';
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import ButtonDefault from "../button/button-default/ButtonDefault";
import {faAngleRight} from "@fortawesome/free-solid-svg-icons";
import BoxRight from "../box-right/BoxRight";
import {ParallaxImageProps} from "../parallax-image/ParallaxImage";

const heroContent = {
    title: "Step into the unseen world of Mystirien",
    src: '/assets/img/map.jpg',
    description: `Here I share my tales of exploration, discoveries, and the magic that unfolds when you venture beyond the ordinary. Join me as I navigate through uncharted territories, uncover hidden gems, and embrace the wonders of the unknown.`,
    to: "/map",
    textButton: "EXPLORE THE MAP",
    icon : faAngleRight
};

function HeroSectionTow({...restProps}: ParallaxImageProps) {
    return (
        <BoxRight  {...restProps} src={heroContent.src}>
            <FadeUpTrigger>
                <h2 className="pre-line">{heroContent.title}</h2>

                <p className="mt-30 m-w750 dsn-auto">{heroContent.description}</p>
                <ButtonDefault className="mt-30" icon={heroContent.icon} text={heroContent.textButton}
                               to={heroContent.to}/>
            </FadeUpTrigger>
        </BoxRight>
    );
}

export default HeroSectionTow;